/**
 * @param {Object}
 * @returns {Object} to store in storage like cookies or localStorage
 * */
 export function prepareTokenForStore(data) {
  return {
    refresh_token: data.refresh_token,
    roles: data.roles
  }
}

export const editFunctionality = (roles) => {
  const adminRole = "ROLE_STADMIN";

  return roles.split(",").includes(adminRole);
};

